export { default as gdprTextForTax } from "./tax"
export { default as gdprTextDefault } from "./default"
export { default as gdprTextForVub } from "./vub"
export { default as gdprTextForCub } from "./cub"
export { default as gdprTextForSta } from "./sta"
export { default as gdprTextForAdr } from "./adr"